import React from 'react'
import Icon from './Icon'

import { Dropdown } from 'bootstrap.native'

import '../styles/activeCallList-filter'

class UnitDropDown extends React.Component {

    initializeDropdown(element, persist) {
        if (element && !element.Dropdown) {
            new Dropdown(element, persist)
        }
    }

    render() {
        const { className, filter, onChange, units } = this.props
        const allUnits = filter == null || filter && filter.length == units.length
        const unitsFilterSelectionText = allUnits ? 'All' : filter.length > 0 ? filter.map(key => units.find(u => u.key == key) || key).map(u => u.name || u).join(',') : 'None'
        const checkedIconProps = { prefix: 'fa', icon: 'check-square-o' }
        const uncheckedIconProps = { prefix: 'fa', icon: 'square-o' }
        const indeterminateIconProps = { prefix: 'fa', icon: 'square' }

        return (
            <div className="units dropdown">
                <button type="button" className="btn btn-default dropdown-toggle" ref={e => { if(units.length) { this.initializeDropdown(e, true) } }}>
                    Units <span className="small">[{unitsFilterSelectionText}]</span>&nbsp;&nbsp;<span className="caret"></span>
                </button>
                <ul className="dropdown-menu">
                    <li>
                        <a href="#" ref={e => this.allUnitsCheckbox = e} onClick={e => { e.preventDefault(); onChange(allUnits ? [] : null); }}>
                            <Icon {...(allUnits ? checkedIconProps : filter && filter.length ? indeterminateIconProps : uncheckedIconProps) } />
                            All
                        </a>
                    </li>
                    <li role="separator" className="divider"></li>
                    {units.map(unit => {
                        const isChecked = (filter && filter.indexOf(unit.key) > -1) || allUnits
                        let nextUnits = isChecked ? (filter || []).filter(u => u != unit.key) : [ ...(filter || []), unit.key ]

                        if (allUnits) {
                            nextUnits = units.map(u => u.key).filter(k => k != unit.key)
                        }

                        return (
                            <li key={unit.key}>
                                <a href="#" tabIndex="-1" onClick={e => { e.preventDefault(); onChange(nextUnits) }}>
                                    <Icon {...(isChecked ? checkedIconProps : uncheckedIconProps) } />
                                    {unit.name}
                                </a>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}

export default UnitDropDown



// WEBPACK FOOTER //
// ./components/UnitDropDown.jsx